import { faMapMarkerAlt, faUser } from "@fortawesome/free-solid-svg-icons";

import AnchorButton from "../../components/AnchorButton";
import Banner from "../../components/Banner";
import Collaborators from "../../components/Collaborators";
import Container from "../../components/Container";
import ContainerDivider from "../../components/ContainerDivider";
import FeaturedHeader from "../../components/FeaturedHeader";
import Footer from "../../components/Footer";
import Icon from "../../components/Icon";
import Navbar from "../../components/Navbar";
import React from "react";
import ReactMarkdown from "react-markdown";
import SampleBannerImage from "../../statics/img/banner-sample-02.jpg";
import Spacer from "../../components/Spacer";
import SubscriptionSection from "../../components/SubscriptionSection";
import getTime from "../../helpers/getTime";
import useEvent from "../../hooks/useEvent";
import { useParams } from "react-router-dom";
import useSpeaker from "../../hooks/useSpeaker";

const Speaker = () => {
  const { speakerID } = useParams<{
    speakerID?: string;
  }>();

  const event = useEvent();
  const speaker = useSpeaker(speakerID) || {};

  const {
    firstname,
    lastname,
    position,
    image,
    cover,
    bio,
    email,
    institute,
    city,
    country,
  } = speaker;

  return (
    <div className="SpeakerPage">
      <Navbar />
      <FeaturedHeader image={cover}>
        <div className="lg:pb-20">
          <div className="text-3xl font-medium leading-tight">{position}</div>
          <h1 className="mt-2 text-5xl font-bold leading-none">
            — {firstname} {lastname}
          </h1>
          <div className="mt-4 text-xs text-gray-400">
            <Icon icon={faMapMarkerAlt} /> {city}, {country}
          </div>
        </div>
      </FeaturedHeader>

      <div className="container relative px-4 py-12 mx-auto">
        <div className="absolute top-0 w-4/12 transform -translate-y-1/2 md:w-3/12 lg:w-2/12">
          <div
            className="relative bg-gray-200 bg-center bg-no-repeat bg-cover rounded-full shadow-xl"
            style={{
              backgroundImage: `url(${image})`,
              paddingTop: "100%",
            }}
          >
            {image ? null : (
              <div className="absolute top-0 left-0 flex items-center justify-center w-full h-full">
                <Icon icon={faUser} />
              </div>
            )}
          </div>
        </div>
      </div>

      <Container>
        <div className="flex w-full mt-12 space-x-8">
          {bio || email ? (
            <div className="w-8/12 space-y-4">
              {bio ? (
                <>
                  <div className="text-lg font-medium text-aqua">
                    Professional Bio
                  </div>
                  <div className="space-y-4 text-base leading-loose">
                    <ReactMarkdown source={bio.replace(/\\n/g, "\n")} />
                  </div>
                </>
              ) : null}
              {email ? (
                <AnchorButton href={`mailto:${email}`} theme="secondary">
                  Send Email
                </AnchorButton>
              ) : null}
            </div>
          ) : null}

          {institute || position || (city && country) ? (
            <div className="w-4/12 space-y-4">
              <div className="text-lg font-medium text-aqua">About Me</div>
              {institute ? (
                <div className="space-y-2">
                  <div className="text-sm text-gray-400">Insititute:</div>
                  <div className="text-sm">{institute}</div>
                </div>
              ) : null}

              {position ? (
                <div className="space-y-2">
                  <div className="text-sm text-gray-400">Position:</div>
                  <div className="text-sm">{position}</div>
                </div>
              ) : null}

              {city && country ? (
                <div className="space-y-2">
                  <div className="text-sm text-gray-400">Location:</div>
                  <div className="text-sm">
                    {city}, {country}
                  </div>
                </div>
              ) : null}
            </div>
          ) : null}
        </div>

        {getTime() > getTime("28 Nov 2020") ? null : (
          <Spacer>
            <div className="text-white">
              <Banner
                header="Join us on"
                title="Dental education and research during COVID-19 pandemic."
                button={{
                  to: `/${event}/virtual-room/1`,
                  text: "Watch Live Conference",
                }}
                bgImage={SampleBannerImage}
              />
            </div>
          </Spacer>
        )}
      </Container>

      <Spacer>
        <ContainerDivider />
        <Collaborators />
      </Spacer>

      <SubscriptionSection />
      <Footer />
    </div>
  );
};

export default Speaker;
